<template>
  <div style="font-size: 11px">
    <div class="d-flex align-items-center">
      <img src="@/assets/images/star.svg" alt="star" width="10" />
      <div class="ms-2">
        كليه آثار مجموعه هنري كلاهدوزان، هنر دست ساز اساتيد برجسته صنايع دستي است .
      </div>
    </div>
    <div class="d-flex align-items-center mt-3">
      <img src="@/assets/images/star.svg" alt="star" width="10" />
      <div class="ms-2">
        طراحي و خلق آثار مربوط به مجموعه كلاهدوزان مي باشد و مالكيت مادي و معنوي متعلق به اين مجموعه است.
      </div>
    </div>
    <div class="d-flex align-items-center mt-3">
      <img src="@/assets/images/star.svg" alt="star" width="10" />
      <div class="ms-2">
        با خريد از مجموعه هنري كلاهدوزان شما صاحب يك كالا صنعتی نيستيد بلكه يك اثر هنري دريافت كرده ايد كه به مرور زمان ارزش آن بيشتر مي شود .
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style></style>
